const {ccclass, property} = cc._decorator;

@ccclass
export default class BackpackMenu extends cc.Component {

    @property({ type: cc.Node, displayName: "背景框" })
    bg: cc.Node = null;
    @property({type:cc.Label,displayName:"描述文本"})
    lb_Explain:cc.Label = null;

    str:string = "";
    //绑定数据
    bindData(str:string){
        this.str = str;
        this.updateMenu();
    }

    updateMenu(){
        let s = /[\u4e00-\u9fa5|\u3002|\uff1f|\uff01|\uff0c|\u3001|\uff1b|\uff1a|\u201c|\u201d|\u2018|\u2019|\uff08|\uff09|\u300a|\u300b|\u3008|\u3009|\u3010|\u3011|\u300e|\u300f|\u300c|\u300d|\ufe43|\ufe44|\u3014|\u3015|\u2026|\u2014|\uff5e|\ufe4f|\uffe5]/
        let maxLength:number = 26;
        let currentLength:number = 0;
        let str:string = "";
        let rowLength:number = 1;
        for(let i = 0;i<this.str.length;i++){
            let ss = this.str[i];
            let isTrue = s.test(ss);
            if(isTrue){
                if(currentLength + 2 <= maxLength){
                    currentLength += 2;
                    str += ss;
                }else{
                    rowLength ++;
                    str += "\n";
                    str += ss;
                    currentLength = 2;
                }
            }else{
                if(currentLength + 1 <= maxLength){
                    currentLength += 1;
                    str += ss;
                }else{
                    rowLength ++;
                    str += "\n";
                    str += ss;
                    currentLength = 1;
                }
            }
        }
        let width:number = 0;
        let height:number = 0;
        height = rowLength * this.lb_Explain.lineHeight;
        if(rowLength >= 2){
            // 行数超过两行  高度需要变化 宽度保持最大
            width = maxLength / 2 * this.lb_Explain.fontSize;
        }else{
            // 行数不到2行 高度保持一行的高度 宽度按照字数排
            width = currentLength / 2 * this.lb_Explain.fontSize;
        }
        this.bg.width = width + 10;
        this.bg.height = height + 10;
        this.node.width = width + 10;
        this.node.height = height + 10;
        this.lb_Explain.string = str;
    }

    start(){
    }

}
